import Component from '@glimmer/component';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#unless @custom_field.organization_custom_field.disabled}}\n  <BbField\n    @classLabel={{this.classLabel}}\n    @classText={{this.classText}}\n    @label={{@custom_field.organization_custom_field.name}}\n  >\n    <CustomFieldValue @custom_field={{@custom_field}} @me={{@me}} />\n  </BbField>\n{{/unless}}\n");

class ViewCustomFieldComponent extends Component {
  get classLabel() {
    return this.args.classLabel ?? 'small-12 medium-3 cell beebeeLabel';
  }
  get classText() {
    return this.args.classText ?? 'cell small-12 medium-9';
  }
}
setComponentTemplate(TEMPLATE, ViewCustomFieldComponent);

export { ViewCustomFieldComponent as default };
//# sourceMappingURL=view-custom-field.js.map
